'use client'

import { Image, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { IMAGE_BASE_URL } from '../../../constants'

type Props = {
  index: 1 | 2 | 3 | 4
}

const Step = ({ index }: Props) => {
  const translate = useTranslate(`item_verification.how_it_works.step_${index}`)

  return (
    <div
      className="item-verification__how-it-works-step"
      role="listitem"
      data-testid={`howitworks-item-${index}`}
    >
      <article className="item-verification__how-it-works-step-image">
        <Image
          src={`${IMAGE_BASE_URL}/step-${index}.png`}
          srcset={`${IMAGE_BASE_URL}/step-${index}.png 333w, ${IMAGE_BASE_URL}/step-${index}-tablets-up.png 620w, ${IMAGE_BASE_URL}/step-${index}@2x.png 666w, ${IMAGE_BASE_URL}/step-${index}-tablets-up@2x.png 1240w`}
          sizes="(max-width: 720px) calc(100vw - 18px), calc(50vw - 57px)"
          scaling={Image.Scaling.Cover}
          loading="lazy"
        />
      </article>
      <div className="u-flexbox u-flex-direction-row">
        <div className="item-verification__how-it-works-step-index">{index}</div>
        <div className="u-ui-padding-left-x3-large">
          <h3 className="item-verification__how-it-works-step-title">{translate('title')}</h3>
          <Spacer size={Spacer.Size.Medium} />
          <p className="item-verification__how-it-works-step-description">
            {translate('description')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Step
